import type {IPlannerRoomNames} from "../../../types/planner_property/IPlannerRoomNames";
import type {RoomWithRequiredExposure} from "./get_only_rooms_with_exposure";

export const countRoomsByType = (rooms: RoomWithRequiredExposure[]) => {
    return rooms.reduce(
        (acc, room) => {
            acc[room.roomTypeNormalized] = acc[room.roomTypeNormalized] ? acc[room.roomTypeNormalized] + 1 : 1;

            return acc;
        },
        {} as Record<IPlannerRoomNames, number>
    );
};
import type {IPlannerRoomNames} from "../../../types/planner_property/IPlannerRoomNames";
import type {RoomWithRequiredExposure} from "./get_only_rooms_with_exposure";

export const countRoomsByType = (rooms: RoomWithRequiredExposure[]) => {
    return rooms.reduce(
        (acc, room) => {
            acc[room.roomTypeNormalized] = acc[room.roomTypeNormalized] ? acc[room.roomTypeNormalized] + 1 : 1;

            return acc;
        },
        {} as Record<IPlannerRoomNames, number>
    );
};
